<template>
  <div>
    <!-- Header Section -->
    <ProfileHeader />

    <div class="grid gap-6 grid-cols-1 xl:grid-cols-3">
      <!-- Left Column -->
      <div class="col-span-1 space-y-6">
        <!-- Connected Accounts Section -->
        <ContentCard title="Connected Accounts">
          <ConnectedAccounts />
        </ContentCard>
      </div>

      <!-- Right Column -->
      <div class="col-span-1 xl:col-span-2 space-y-6">
        <!-- General Information Section -->
        <ContentCard title="General Information">
          <GeneralInformation
            :profile="profile"
            :loading="loadingProfile"
            @update="handleUpdateProfile" />
        </ContentCard>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { hideLoadingSpinner } from '~/javascript/utils/hide_loader.js'
import { useProfileData } from '~/javascript/composables/use_profile_data'

// Import profile components
import ProfileHeader from './components/profile_header.vue'
import ContentCard from './components/content_card.vue'
import ConnectedAccounts from './components/connected_accounts.vue'
import GeneralInformation from './components/general_information.vue'

// Composables
const {
  profile,
  loadingProfile,
  fetchProfile,
  updateProfile
} = useProfileData()

// Event handlers
const handleUpdateProfile = async(data) => {
  try {
    await updateProfile(data)
    // Handle success notification
  } catch (error) {
    console.error('Failed to update profile:', error)
    // Handle error notification
  }
}

// Lifecycle
onMounted(async() => {
  hideLoadingSpinner()

  try {
    await fetchProfile()
  } catch (error) {
    console.error('Failed to load profile data:', error)
  }
})
</script>
